import React, { PureComponent } from 'react'
import { localize } from 'helpers/translator'

class TermsAndConditionsError extends PureComponent {

	render() {
		if (this.props.meta.error && this.props.meta.touched) {
			return <span className={this.props.style_data}>{localize('signUp_form_mustAcceptTerms')}</span>
		} else {
			return null
		}
	}
}

export default TermsAndConditionsError
